import {
    GET_PRODUCTION_PLANNING_LIST_PROGRESS, GET_PRODUCTION_PLANNING_LIST_SUCCESS, GET_PRODUCTION_PLANNING_LIST_FAILURE,
    ADD_PRODUCTION_PLANNING_PROGRESS, ADD_PRODUCTION_PLANNING_SUCCESS, ADD_PRODUCTION_PLANNING_FAILURE,
    EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS, EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS, EDIT_DELETE_PRODUCTION_PLANNING_FAILURE,
    ////


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    production_planning: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const production_planning_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_PRODUCTION_PLANNING_LIST_SUCCESS:
            return { ...state, production_planning: action.production_planning, loading: false };
        case GET_PRODUCTION_PLANNING_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PRODUCTION_PLANNING_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PRODUCTION_PLANNING_PROGRESS:
            return { ...state, loading: true };
        case ADD_PRODUCTION_PLANNING_SUCCESS:
            return { ...state, production_planning: [...state.production_planning, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PRODUCTION_PLANNING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_PRODUCTION_PLANNING_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PRODUCTION_PLANNING_SUCCESS:
            return {
                ...state,
                production_planning: state.production_planning.map((production_planning) =>
                    production_planning.id === action.payload.id ? action.payload : production_planning
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_PRODUCTION_PLANNING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default production_planning_reducer;